import { useDispatch, useSelector } from 'react-redux';

import { selectUserInfo, updateContactInfo, updateContactInfoSMB } from '@app/redux/userInfo';

import { AccountType, Role, UpdateAccountInfoInput, UpdateAccountInfoSmbInput } from '@mfe/shared/schema-types';

type IraContactInfoPayload = Partial<UpdateAccountInfoInput> | Partial<UpdateAccountInfoSmbInput>;

export const useSaveInIra = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector(selectUserInfo);
  const { accountType } = userInfo;
  const isSMB = accountType === AccountType.Smb;

  // Should only update primary email adress, not viasat_my_sso_ldap
  const shouldUpdateLoginUsername = false;

  const saveInIra = (contactInfo: IraContactInfoPayload) => {
    const basePayload: UpdateAccountInfoInput = {
      ...contactInfo,
      shouldUpdateLoginUsername,
    };

    const smbContactInfo = contactInfo as Partial<UpdateAccountInfoSmbInput>;
    const smbRole = smbContactInfo.role ?? (smbContactInfo.addresses ? Role.Customer : Role.AccountHolder);

    const smbPayload: UpdateAccountInfoSmbInput = {
      ...basePayload,
      role: smbRole,
    };

    if (isSMB) {
      dispatch(updateContactInfoSMB(smbPayload));
    } else {
      dispatch(updateContactInfo(basePayload));
    }
  };

  return saveInIra;
};
